import React, { FC } from "react"
import { Switch } from "react-router"
import { Redirect, Route } from "react-router-dom"
import ActivateContainer from "components/containers/activate/ActivateContainer"
import ActivateDone from "components/views/activate/ActivateDone"
import ActivateSuccess from "components/views/activate/ActivateSuccess"
import SubmitReimbursementContainer from "components/containers/reimbursements/SubmitReimbursementContainer"
import { useSelector } from "react-redux"
import { getCarrotLite } from "reducers/companyInfo"

const ReimbursementsRouter: FC = () => {
  const carrotLite = useSelector(getCarrotLite)

  return (
    <Switch>
      {carrotLite && <Redirect to="/" />}
      <Redirect exact path="/reimbursements" to="/transactions" />
      <Route exact path="/reimbursements/activate" component={ActivateContainer} />
      <Route exact path="/reimbursements/activate/done" component={ActivateDone} />
      <Route exact path="/reimbursements/activate/success" component={ActivateSuccess} />
      <Route component={SubmitReimbursementContainer} />)
    </Switch>
  )
}

export { ReimbursementsRouter }
